const COLUMN_COUNT = 5 as const;
const ROW_COUNT = 6 as const;
const FEEDBACK_TIMEOUT = 2000 as const;

export {
  COLUMN_COUNT,
  FEEDBACK_TIMEOUT,
  ROW_COUNT,
};
